import React from "react";
import styled from "styled-components";
import { FaPlay } from "react-icons/fa";

const boardOfDirectoryData = [
  {
    id: 1,
    img: "/assets/images/about/images-11.jpg",
    name: "Md. Siddiqul Alam",
    position: "Group Managing Director",
    desc: `Md. Siddiqul Alam is a highly experienced leader with a strong background in business management and strategic planning. Over the years, he has played a key role in driving organizational growth, ensuring operational excellence, and building long-term business sustainability. His leadership focuses on innovation, efficiency, and maintaining high standards across all sectors.`,
  },
  {
    id: 2,
    img: "/assets/images/about/images-11.jpg",
    name: "Yeasmin Alam",
    position: "Group Chairman",
    desc: `Yeasmin Alam brings extensive experience in corporate governance and leadership. With a clear vision for the organization, she is responsible for guiding long-term strategies and ensuring strong business performance. Her focus includes sustainable development, ethical business practices, and strengthening the company’s overall direction.`,
  },
  {
    id: 3,
    img: "/assets/images/about/images-11.jpg",
    name: "Md. Irfan Alam",
    position: "Group CEO",
    desc: `Md. Irfan Alam is responsible for overseeing daily operations and executing business strategies across all departments. With a results-driven approach, he ensures smooth coordination between teams, enhances productivity, and drives continuous improvement. His leadership emphasizes innovation, growth, and customer satisfaction.`,
  },
];

const BoardOfDirectory = () => {
  return (
    <Wrapper>
      <section className="rs-about-area section-space rs-about-thirteen has-space p-relative z-index-">
        <div
          className="rs-counter-bg-thumb"
          style={{
            backgroundImage: "url(/assets/images/about/counter-bg-01.png)",
          }}
        ></div>

        <div className="container">
          <div className="row g-5 justify-content-center section-title-space align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6">
              <div className="rs-section-title-wrapper text-center">
                <span className="rs-section-subtitle has-theme-orange">
                  <FaPlay color="#EA5501" size={12} />
                  Board Of
                </span>
                <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                  Directory
                </h2>
              </div>
            </div>
          </div>

          {boardOfDirectoryData.map((item) => (
            <div className="team-card" key={item.id}>
              <div className="team-img">
                <img src={item.img} alt={item.name} />
              </div>

              <div className="team-info">
                <h4>{item.name}</h4>
                <span>{item.position}</span>
                <p className="text-justify">{item.desc}</p>
              </div>
            </div>
          ))}

          {/* 
          <div className="team-card">
            <div className="team-img">
              <img
                src="assets/images/about/images-11.jpg"
                alt="Mr. Abul Hashem"
              />
            </div>

            <div className="team-info">
              <h4>Mr. Abul Hashem</h4>
              <span>GROUP MANAGING DIRECTOR</span>
              <p className="text-justify">
                Mr. Abul Hashem is the Managing Director of the Group. He is the
                second son of the Group Founder. He holds a Bachelor of Arts
                degree from the University of Chittagong. He holds the Managing
                Director position in almost all the companies of the group. He
                is looking after group administration, development and CSR
                activities in addition to performing the responsibilities as
                Managing Director.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-img">
              <img
                src="assets/images/about/images-11.jpg"
                alt="Mr. Abu Syed Chowdhury"
              />
            </div>

            <div className="team-info">
              <h4>Mr. Abu Syed Chowdhury</h4>
              <span>GROUP DEPUTY MANAGING DIRECTOR</span>
              <p className="text-justify">
                Mr. Abu Syed Chowdhury is the Deputy Managing Director of the
                Group and the third son of the Group Founder. He holds an MBA
                from University of Chittagong. He is responsible for driving the
                Group business operation, including manufacturing, sales and
                other support functions. He is the President of Chittagong
                University MBA Association.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-img">
              <img
                src="assets/images/about/images-11.jpg"
                alt="Mr. Shah Shafiqul Islam"
              />
            </div>

            <div className="team-info">
              <h4>Mr. Shah Shafiqul Islam</h4>
              <span>GROUP DIRECTOR</span>
              <p className="text-justify">
                Mr. Shah Shafiqul Islam is the Director of the Group. He is the
                fourth son of the Group Founder. He holds a Master of Commerce
                degree from the University of Chittagong. He is looking after
                the Steel Long and Flat Marketing Operation, Transport and Baby
                Food Business of the Group.
              </p>
            </div>
          </div> */}
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .team-card {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    align-items: flex-start;
  }

  /* ✅ IMAGE BOX */
  .team-img {
    flex: 0 0 140px;
    /* height: 150px;               */
    overflow: hidden; /* IMPORTANT */
    border-radius: 25px; /* ROUND BORDER */
    border: 2px solid #ddd; /* BORDER */
  }

  /* ✅ IMAGE FULL COVER INSIDE BOX */
  .team-img img {
    width: auto;
    height: 100%;
    cursor: auto;
    /* center focus */
    display: block;
  }

  /* TEXT */
  .team-info h4 {
    margin: 0;
    font-size: 20px;
  }

  .team-info span {
    display: block;
    font-weight: 600;
    margin: 5px 0 10px;
  }

  .team-info p {
    font-size: 14px;
    color: #555;
    line-height: 1.6;
    text-align: justify;
  }

  .rs-about-area .rs-counter-bg-thumb {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom right;
    z-index: -1;
  }

  /* =======================
     MEDIUM SCREEN
  ======================= */
  @media (max-width: 991px) {
    .team-img {
      flex: 0 0 140px;
      /* height: 120px; */
    }

    .team-info h4 {
      font-size: 18px;
    }
  }

  /* =======================
     SMALL SCREEN
  ======================= */
  @media (max-width: 576px) {
    .team-card {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .team-img {
      /* width: 100%; */
      /* max-width: 260px; */
      /* height: 120px; */
    }
  }
`;

export default BoardOfDirectory;
